import { Form, Input } from 'antd'
import React, { useContext, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { cashFlowStatementGraphReportSelector } from '../../../../../../../redux/config/cashFlowStatement/selectors'
import { contextRequest } from '../../../../../../../redux/context/actions'
import { getCashFlowStatementRequest } from '../../../../../../../redux/context/reports/actions'
import { cashFlowStatementSelector } from '../../../../../../../redux/context/reports/selectors'
import { AppDispatch } from '../../../../../../../redux/store'
import { sleep } from '../../../../../../../utils/helpers'
import { CompanyDashboardItemContext } from '../../DashboardItemProvider'
import DashboardItemFields from '../DasboardItemFieds'
import SelectionTableInput from '../SelectionTableInput'
import { contextCompanyIdSelector } from '../../../../../../../redux/context/company/selectors'
import { useCtxDimensions } from '../../../../../../../features/dimension/queries/useCtxDimensions'
import { useDimensionQuery } from '../../../../../../../features/dimension/hooks/hooks'
import { filtersSelector } from '../../../../../../../redux/context/filters/selectors'

const CashFlowChartItemFields = () => {
  const { t } = useTranslation()
  const dispatch: AppDispatch = useDispatch()
  const companyId = useSelector(contextCompanyIdSelector)!
  const { dimensions } = useSelector(filtersSelector)
  const { isLoading: dimensionsLoading } = useCtxDimensions()
  const dimensionQuery = useDimensionQuery()
  const form = Form.useFormInstance()
  const { companyDashboardItemPreferenceSelection } = useContext(CompanyDashboardItemContext)!
  const {
    params: { type, selectedGraph }
  } = companyDashboardItemPreferenceSelection!

  const rowsSelector = useMemo(() => cashFlowStatementGraphReportSelector(type, selectedGraph), [type, selectedGraph])
  const cashFlowStatement = useSelector(cashFlowStatementSelector)
  const rows = useSelector(rowsSelector)

  useEffect(() => {
    if (!cashFlowStatement.length && ((dimensions?.length && !dimensionsLoading) || !dimensions?.length)) {
      dispatch(contextRequest(getCashFlowStatementRequest))
    }
  }, [companyId, dimensionQuery])

  const columns = [
    {
      title: t(`global:name`),
      dataIndex: 'title'
    }
  ]

  useEffect(() => {
    if (!cashFlowStatement.length || rows.some((row: any) => row.id == null)) return
    const updateSelectedRows = async () => {
      // TODO: hax fix me
      await sleep(1)
      const ids = rows.map((c: any) => c.id)
      form.setFieldValue(['params', 'selectedRows'], ids)
    }
    updateSelectedRows()
  }, [cashFlowStatement.length, companyDashboardItemPreferenceSelection, rows, form])

  return (
    <>
      <DashboardItemFields />
      <Form.Item hidden label={t(`cashFlowPage:${selectedGraph}`)} name={['params', 'selectedGraph']}>
        <Input />
      </Form.Item>
      <Form.Item label={t(`cashFlowPage:${selectedGraph}`)} name={['params', 'selectedRows']}>
        <SelectionTableInput dataSource={rows} columns={columns} />
      </Form.Item>
    </>
  )
}

export default CashFlowChartItemFields
